import { merge } from 'lodash'

class Linkable {

  constructor(link) {
    this.type = 'href'
    this.href = ''
    this.title = ''

    if (link) {
      merge(this, link)
    }
  }

  remove() {
    this.type = 'href'
    this.href = ''
    this.title = ''
  }

}

export default Linkable



// WEBPACK FOOTER //
// ./src/models/linkable.js